<div class="d-grid grid-1-col gap-4">
@if (contactList != undefined && contactList.length > 0) {
  <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isContactAcct" name="isContactAcct" [disabled]="lockIsContact()">
    <span>Contact Account</span>
  </mat-slide-toggle>

  @if (isContactAcct()) {
    <div>
      <label for="contact">Contact Name</label>
      <select class="form-select" name="contact" id="contact" [(ngModel)]="selectedContactId">
      @for (contact of contactList; track contact.ID) {
        <option [ngValue]="contact.ID">{{ contact.Name }}</option>
      }
      </select>
    </div>
  }
}

<div>
  <label for="bankOption">Bank</label>
  <select class="form-select" name="bankOption" id="bankOption" [ngModel]="isOtherBank() ? 'Other' : account().Bank" (ngModelChange)="bankChanged($event)">
    <option value="Other">Other</option>
  @for (b of BANK_CONFIG; track b.code) {
    <option [value]="b.bankName">{{ b.bankName }}</option>
  }
  </select>
</div>

@if (isOtherBank()) {
  <div>
    <label for="bank">Other (Please specify bank name)</label>
    <input type="text" required class="form-control" name="bank" id="bank" [(ngModel)]="account().Bank" (keypress)="!sharedService.isNumberKey($event)" />
  </div>
}

<div>
  <label for="accountNumber">Account Number</label>
  <input type="text" required class="form-control" name="accountNumber" id="accountNumber" [(ngModel)]="account().AccountNumber" (keypress)="sharedService.isNumberKey($event)" />
</div>

<div>
  <label for="holderName">Holder Name <small>(If different from contact/owner name)</small></label>
  <input type="text" required class="form-control" name="holderName" id="holderName" [(ngModel)]="account().HolderName" (keypress)="!sharedService.isNumberKey($event)" />
</div>

<div>
  <label for="remark">Remark</label>
  <input type="text" required class="form-control" name="remark" id="remark" [(ngModel)]="account().Remark" />
</div>

  <div class="d-flex gap-2 justify-content-end">
		<button class="btn btn-primary" type="button" (click)="submit()" [disabled]="disabledSubmit">Add</button>
		<button class="btn btn-light" type="button" (click)="dismiss()">Cancel</button>
  </div>
</div>